module.exports = __webpack_public_path__ + "static/img/complete_bodyfriend.35afbd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/complete_bodyfriend.png
// module id = cX9Z
// module chunks = 1